module.exports = __webpack_public_path__ + "static/media/subscription1.2f756c9b.png";